<div [formGroup]="formGroup">
  <app-content-header text="Add-ons"></app-content-header>

  <div class="mb-3 lato">Treat your pup to more during their stay!</div>

  <div style="margin-top: 1.5rem">
    <div *ngIf="availableAddonServices.length > 0">
      <div
        *ngFor="let pet of addonServiceFormArray.controls; let i = index"
        style="margin-bottom: 0.5rem"
      >
        <div
          class="reservation-pet-tile-form-container"
          *ngIf="addonServiceFormArray.controls.length > 1"
        >
          <div
            class="row no-gutters"
            [ngClass]="{ 'row-dog-tile': pet.value.isSelected }"
          >
            <div class="col-auto">
              <mat-checkbox
                #elem
                aria-label="togglePet"
                [checked]="pet.value.isSelected"
                (change)="elem.checked !== pet.value.isSelected && togglePet(i)"
                style="margin-right: 0.625rem"
              ></mat-checkbox>
            </div>
            <div class="col clickable" (click)="togglePet(i)">
              <ng-container>
                <div class="lato bold primary mt-1">{{ pet.value.name }}</div>
                <div class="pet-info-table">
                  <div class="row no-gutters">
                    <div class="pet-info-label">Breed:</div>
                    <div class="pet-tile-form-content col">
                      {{ pet.value.breed }}
                    </div>
                  </div>
                  <div class="row no-gutters">
                    <div class="pet-info-label col-auto pr-2">Weight:</div>
                    <div class="pet-tile-form-content col">
                      {{ pet.value.weight + " lbs" }}
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <ng-container *ngIf="pet.value.isSelected">
            <app-reservation-dog-add-ons
              [formGroup]="pet"
              [useSpacing]="false"
              [reservationRequest]="reservationRequest.clone()"
              (selectedAddons)="addonServiceUpdated($event)"
            >
            </app-reservation-dog-add-ons>
          </ng-container>
        </div>
      </div>

      <app-reservation-dog-add-ons
        *ngIf="addonServiceFormArray.controls.length === 1"
        [formGroup]="addonServiceFormArray.controls[0]"
        [useSpacing]="true"
        [reservationRequest]="reservationRequest.clone()"
        (selectedAddons)="addonServiceUpdated($event)"
      >
      </app-reservation-dog-add-ons>
    </div>
    <div *ngIf="availableAddonServices.length === 0">
      <div class="row no-gutters">
        <div class="col-auto">
          <div class="lato mt-1">No Add-On available.</div>
        </div>
      </div>
    </div>
    <!--
    <div class="input-container" style="margin-bottom: 0.25rem">
      <div class="d-flex">
        <div style="flex: 1">
          <span class="input-label">Anything else we can do for your pup?</span>
        </div>
      </div>
      <textarea
        title="reservationNotes"
        class="input"
        rows="5"
        formControlName="reservationNotes"
        style="resize: none; height: 100%"
      ></textarea>
    </div>
-->
    <hr />
    <footer class="footer-action">
      <button
        class="btn btn-danger btn-block"
        (click)="onSave()"
        [disabled]="!isSaveEnabled()"
      >
        Review Request
      </button>
    </footer>
  </div>
</div>
